import { Link } from "react-router-dom";
import { ArrowRight, HeartHandshake, ExternalLink } from "lucide-react";

export default function FoundationSection() {
  return (
    <section
      data-testid="foundation-section"
      className="relative py-24 md:py-32 bg-teh-deep text-white overflow-hidden"
    >
      <div className="teh-container">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-6">
            <div className="aspect-[4/5] rounded-2xl overflow-hidden border border-white/10">
              <img
                src="https://images.pexels.com/photos/5206930/pexels-photo-5206930.jpeg"
                alt="Caregiver supporting a patient"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <div className="lg:col-span-6 lg:pl-8">
            <div className="flex items-center gap-3 mb-6">
              <HeartHandshake className="w-6 h-6 text-emerald-300" strokeWidth={1.5} />
              <p className="text-xs font-semibold uppercase tracking-[0.22em] text-emerald-300">
                Community Partner · 501(c)(3)
              </p>
            </div>

            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-white leading-[1.05] tracking-tight">
              Guardian Grace
              <br />
              <span className="italic text-emerald-300/90">Family & Community Foundation.</span>
            </h2>

            <p className="mt-8 text-lg text-white/90 leading-relaxed max-w-xl">
              Our community partner — a 501(c)(3) nonprofit extending the mission beyond the clinic
              by supporting caregivers, individuals with disabilities, veterans, and underserved
              populations through education, advocacy, and direct community outreach.
            </p>

            <ul className="mt-10 space-y-4">
              {[
                "Caregiver respite & education grants",
                "Veteran-focused community programs",
                "Scholarships for healthcare workforce entrants",
                "Disability advocacy & resource navigation",
              ].map((item) => (
                <li key={item} className="flex items-start gap-3 text-white">
                  <span className="w-1.5 h-1.5 rounded-full bg-emerald-300 mt-2.5" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>

            <div className="mt-12 flex flex-wrap gap-3">
              <a
                href="https://guardiangrace.org/"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="foundation-external"
                className="inline-flex items-center gap-2 px-7 py-4 bg-emerald-500 text-white text-sm font-medium rounded-full hover:bg-emerald-600 hover:gap-3 transition-all duration-300"
              >
                Visit guardiangrace.org
                <ExternalLink className="w-4 h-4" strokeWidth={1.8} />
              </a>
              <Link
                to="/foundation"
                data-testid="foundation-cta"
                className="inline-flex items-center gap-2 px-7 py-4 border border-white/30 text-white text-sm font-medium rounded-full hover:bg-white/10 hover:gap-3 transition-all duration-300"
              >
                Learn about our partnership
                <ArrowRight className="w-4 h-4" strokeWidth={1.8} />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

